import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatTableModule } from "@angular/material/table";
import { NotificationsDialogComponent } from "./notifications-dialog.component";
import { NotificationsDialogService } from "./notifications-dialog.service";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
    ],

    declarations: [NotificationsDialogComponent],
    exports: [NotificationsDialogComponent],
    providers: [NotificationsDialogService],
})
export class NotificationsDialogModule {}